module.exports = __webpack_public_path__ + "img/E80404_B50404_CB0404_FC3333-256px.5c072b84.png";